export default class AbstractToolCollection {
    currentTool;
    previousTool;
    tools = {};

    constructor(provider) {
        this.provider = provider;
    }

    setTool(tool, ...args) {
        let newTool = this.tools[tool];
        if (newTool == this.currentTool) {
            this.currentTool.passArgs(...args);
            return;
        }

        newTool.resetPreviousTool
            ? this.currentTool.deactivate()
            : this.currentTool.deactivateButton();
        if (this.previousTool
            && !this.currentTool.resetPreviousTool
            && newTool != this.previousTool
        ) {
            this.previousTool.deactivate();
        }
        this.previousTool = this.currentTool;
        this.currentTool = newTool;
        this.currentTool.activate(...args);
    }

    setPreviousTool() {
        if (!this.previousTool) {
            return;
        }
        let previousTool = this.previousTool;
        this.currentTool.deactivate();
        this.previousTool = this.currentTool;
        this.currentTool = previousTool;
        this.currentTool.activate();
    }

    getTool(tool) {
        return this.tools[tool];
    }
}
